<template>
  <div class="work-experience">
    <!-- 列表展示 -->
    <template v-if="!edit">
      <div class="work-experience_empty" v-if="data.length === 0">暂无期望职位</div>

      <div class="work-experience_list" v-else>
        <div :class="['experience-item', { 'no-last': index < data.length - 1 }]" v-for="(item, index) in data" :key="index">
          <div class="experience-item_header">
            <div class="header-info">
              <div class="show_box">
                <div class="job_type">{{ item.position_type==1?'全职':'兼职' }}职位</div>
                <div class="hope_work"><span>{{ item.name }}</span><span class="line"></span> <span>{{ item.salary_min/1000 }}-{{ item.salary_max/1000 }} K</span> <span class="line"></span><span
                    class="city">{{ item.city }}、{{ item.other_city }}</span>
                </div>
              </div>
            </div>

            <div class="header-operate">
              <div class="operate-btn" @click="handleEdit(index)">
                <i class="el-icon-edit"></i>
                <span>编辑</span>
              </div>

              <div class="operate-btn" @click="handleDelete(item.position_id)">
                <i class="el-icon-delete-solid"></i>
                <span>删除</span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </template>

    <!-- 编辑 -->
    <template v-else>
      <el-form ref="form" :rules="rules" :label-position="'top'" label-width="80px" :model="formData">
        <div class="row_box">
          <el-form-item label="求职类型" prop="position_type">
            <el-radio-group v-model="formData.position_type">
              <el-radio-button style="margin-right: 20px;" :label="1">全职</el-radio-button>
              <el-radio-button :label="2">兼职</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="期望职位" prop="hope_position_value">
            <el-cascader style="width: 100%;" :show-all-levels="false" v-model="formData.hope_position_value" :options="positionOption" @change="handleChange"></el-cascader>
          </el-form-item>
        </div>
        <div class="row_box">
          <el-form-item label="期望行业" prop="hop_industry_value">
            <el-cascader :props="{ multiple: true }" :value="formData.hop_industry_value" clearable :show-all-levels="false" style="width: 100%;" :options="industryOption" @change="handleChange2"></el-cascader>
          </el-form-item>
          <el-form-item label="期望薪资">
            <div style="display: flex;">
              <el-form-item prop="salary_min" style="margin-right: 0px;width: 45%;">
                <el-select style="width: 100%;" v-model="formData.salary_min" placeholder="请选择" @change="changeMinPrice">
                  <el-option v-for="item in minPriceOption" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select></el-form-item>
              <span style="width: 10%;;display: inline-block;text-align: center;">至</span>
              <el-form-item prop="salary_max" style="margin-right: 0px;width: 45%;">
                <el-select :disabled="maxPriceOption.length==0" style="width: 100%;" v-model="formData.salary_max" placeholder="请选择">
                  <el-option v-for="item in maxPriceOption" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-form-item>
        </div>
        <div class="row_box">
          <el-form-item label="工作城市" prop="city_work_value">
            <el-cascader style="width: 100%;" :show-all-levels="false" v-model="formData.city_work_value" :options="cityOption" @change="handleChange"></el-cascader>
          </el-form-item>
          <el-form-item label="其他感兴趣的城市(选填)">
            <el-cascader style="width: 100%;" :show-all-levels="false" v-model="formData.hope_city_value" :options="cityOption" @change="handleChange"></el-cascader>
          </el-form-item>
        </div>
      </el-form>
    </template>
  </div>
</template>

<script>
import {
  positionOption,
  industryOption,
  cityOption,
  getOptionArray,
} from "../js/data";

export default {
  data() {
    return {
      formData: {
        position_id: null,
        name: "",
        hope_position_value: [],
        position_type: 1,
        industry: null,
        hop_industry_value: [],
        salary_min: null,
        salary_max: null,
        city: null,
        city_work_value: [],
        other_city: null,
        hope_city_value: [],
      },
      rules: {
        position_type: [
          { required: true, message: "请选择求职类型", trigger: "change" },
        ],
        hope_position_value: [
          { required: true, message: "请选择期望职位", trigger: "change" },
        ],
        hop_industry_value: [
          { required: true, message: "请选择期望行业", trigger: "change" },
        ],
        salary_min: [{ required: true, message: "请选择", trigger: "change" }],
        salary_max: [{ required: true, message: "请选择", trigger: "change" }],
        city_work_value: [
          { required: true, message: "请选择工作城市", trigger: "change" },
        ],
      },
      positionOption: positionOption,
      industryOption: industryOption,
      cityOption: cityOption,
      minPriceOption: [],
      maxPriceOption: [],
    };
  },

  props: ["data", "edit", "experience"],

  methods: {
    initData() {
      this.$nextTick(() => {
        console.log("this.experience", this.experience);

        if (this.experience) {
          this.formData.name = this.experience.name;
          this.formData.position_id = this.experience.position_id;
          this.formData.position_type = this.experience.position_type;
          this.formData.industry = this.experience.industry;
          this.formData.salary_min = this.experience.salary_min / 1000;
          this.formData.salary_max = this.experience.salary_max / 1000;
          this.formData.other_city = this.experience.other_city;
          this.formData.city = this.experience.city;
          this.changeMinPrice();

          this.formData.hope_city_value = getOptionArray(
            this.cityOption,
            this.formData.other_city
          )[0];
          this.formData.city_work_value = getOptionArray(
            this.cityOption,
            this.formData.city
          )[0];
          this.formData.hope_position_value = getOptionArray(
            this.positionOption,
            this.formData.name
          )[0];
          this.formData.hop_industry_value = getOptionArray(
            this.industryOption,
            this.formData.industry
          );
          this.handleChange2(this.formData.hop_industry_value);
        }
      });
    },

    handleChange() {},
    // 编辑
    handleEdit(index) {
      this.$emit("edit", index);
    },

    handleDelete(id) {
      this.$confirm("确定删除该工作经历?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$emit("delete", id);
      });
    },

    valid() {
      return new Promise((resolve) => {
        this.$refs["form"].validate((valid) => {
          resolve(valid); // 将验证结果传入resolve
        });
      });
    },
    handleChange2(val) {
      if (val.length > 3) {
        this.$message.warning("期望行业最多选择三个");
        this.formData.hop_industry_value = val.slice(0, 3);
        return;
      }
      this.formData.hop_industry_value = val;
      console.log(val, "pppppppppp");
    },
    getFirstValue(min, max) {
      this.minPriceOption = [];
      for (let i = min; i < max; i++) {
        this.minPriceOption.push({
          label: `${i}k`,
          value: i,
        });
      }
    },
    getSecondValue(min, max) {
      this.maxPriceOption = [];
      for (let i = min; i < max; i++) {
        this.maxPriceOption.push({
          label: `${i}k`,
          value: i,
        });
      }
    },
    changeMinPrice() {
      this.getSecondValue(this.formData.salary_min + 1, 200);
    },
  },

  mounted() {
    this.getFirstValue(1, 200);
    this.initData();
  },
};
</script>

<style lang="scss" scoped>
.work-experience {
  &_empty {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
  }

  &_list {
    .experience-item {
      & + .experience-item {
        margin-top: 16px;
      }

      padding-right: 48px;
      position: relative;

      &_header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .show_box {
          .job_type {
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            margin-bottom: 20px;
          }
          .hope_work {
            font-weight: 400;
            font-size: 16px;
            color: #222223;
            .line {
              width: 1px;
              height: 14px;
              background: #d2d2d3;
              display: inline-block;
              margin: 0 12px;
            }
            .city {
              color: #99999a;
            }
          }
        }
      }

      &_content {
        .content-item {
          display: flex;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #6e6e6e;
          margin-top: 16px;

          & > * {
            flex-shrink: 0;
          }

          &_label {
            width: 45px;
            text-wrap: nowrap;
          }

          &_value {
            flex: 1;
            text-wrap: wrap;
            word-break: break-all;

            p {
              margin: 0;
              word-break: break-all;
              text-wrap: wrap;
            }
          }
        }
      }

      &:hover {
        .header-operate {
          display: flex;
          align-items: center;
          gap: 20px;
        }
      }
      .header-operate {
        display: none;

        .operate-btn {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #685ef5;
          cursor: pointer;

          i {
            margin-right: 2px;
          }
        }
      }
    }
  }

  .row_box {
    width: 100%;
    display: flex;

    .el-form-item {
      flex-shrink: 0;
      width: 400px;

      margin-right: 40px;
    }
  }
}
</style>
